import React, { useState } from "react";
import {
  BaseBox,
  BaseTypography,
  BaseButton,
  BaseTextField,
  BaseCheckbox,
} from "../../../Common/UI/exports";
import {
  readCache,
  writeCache,
  invalidateCache,
} from "../../../APIs/AwsCacheManager";

function AwsCacheManager() {
  const email = localStorage.getItem("email");

  const [keyRef, setKeyRef] = useState("");
  const [key, setKey] = useState("");
  const [data, setData] = useState("");
  const [ttl, setTtl] = useState("");
  const [encode, setEncode] = useState(false);
  const [hash, setHash] = useState(false);
  const [response, setResponse] = useState(null);

  const handleAction = async (action) => {
    try {
      let result;
      switch (action) {
        case "read":
          result = await readCache(keyRef, key, encode, hash);
          break;
        case "write":
          result = await writeCache(key, data, ttl);
          break;
        case "invalidate":
          result = await invalidateCache(keyRef, key, encode, hash);
          break;
        case "clear_response":
          result = null;
          break;
        default:
          return;
      }
      setResponse(result);
    } catch (err) {
      console.error(err);
      setResponse({ error: err.response?.data || err.message });
    }
  };

  return (
      <BaseBox
        sx={{
          height: "calc(100vh - 140px)", 
          display: "flex",
          flexDirection: "column",
          maxWidth: "1160px",
          mx: "auto",
          mt: 0,
          px: 2,
        }}
      >
        <BaseTypography sx={{ fontSize: "1.2rem", mb: 0, fontWeight: 600 }}>
          AWS Cache Manager
        </BaseTypography>

        {/* Form */}
        <BaseBox sx={{ display: "flex", flexDirection: "column", gap: 0 }}>
          <BaseBox sx={{ display: "flex", gap: 2, mt: 2 }}>
            <BaseTextField
              label="Key Ref"
              value={keyRef}
              onChange={(e) => setKeyRef(e.target.value)}
              fullWidth={false}
              sx={{ width: "40%" }}
            />

            <BaseTextField
              label="Key"
              value={key}
              onChange={(e) => setKey(e.target.value)}
              fullWidth={false}
              sx={{ width: "40%" }}
            />

            <BaseTextField
              label="TTL (for write)"
              type="number"
              value={ttl}
              onChange={(e) => setTtl(e.target.value)}
              fullWidth={false}
              sx={{ width: "40%" }}
            />

            <BaseBox
              sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 3 }}
            >
              <BaseCheckbox
                label="Encode"
                checked={encode}
                onChange={() => setEncode(!encode)}
                sx={{ width: "10%" }}
              />
              <BaseCheckbox
                label="Hash"
                checked={hash}
                onChange={() => setHash(!hash)}
                sx={{ width: "10%" }}
              />
            </BaseBox>
          </BaseBox>

          <BaseTextField
            label="Cache Data"
            multiline
            rows={8}
            value={data}
            onChange={(e) => setData(e.target.value)}
          />

          {/* Buttons below table */}
          <BaseBox sx={{ display: "flex", gap: 2, mt: 2 }}>
            <BaseButton
              onClick={() => handleAction("clear_response")}
              color="info"
            >
              Clear Response
            </BaseButton>
            <BaseButton onClick={() => handleAction("read")} color="secondary">
              Read
            </BaseButton>
            <BaseButton onClick={() => handleAction("write")} color="secondary">
              Write
            </BaseButton>
            <BaseButton
              onClick={() => handleAction("invalidate")}
              color="primary"
            >
              Invalidate
            </BaseButton>
          </BaseBox>
        </BaseBox>

        {/* Response */}

        <BaseBox sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <BaseTextField
            label="Response"
            value={response ? JSON.stringify(response, null, 2) : ""}
            fullWidth
            multiline
            rows={8}
          />
        </BaseBox>
      </BaseBox>
  );
}

export default AwsCacheManager;
